export { DocsSearchService } from './services/docs-search';
export {
  classifyBlockSourceType,
  isSearchSourceType,
  type SearchSourceType,
} from './services/search-source';
export {
  type AttachmentNavigation,
  buildDocsSearchNavigation,
  createDocsSearchNavigationResolvers,
  type DocNavigation,
  type DocsBlockPayload,
  type DocsPayload,
  type DocsPdfAttachmentHeaderPayload,
  type DocsPdfDocHeaderPayload,
  type DocsPdfPagePayload,
  type DocsSearchBlockStatus,
  type DocsSearchNavigablePayload,
  type DocsSearchNavigation,
  type DocsSearchNavigationResolvers,
  type DocsSearchResult,
  getDocsPayloadSourceTypes,
  getDocsSearchLocationIdentity,
  isDocsPdfPagePayload,
  openDocsSearchNavigation,
  type OpenDocsSearchNavigationOptions,
  type PdfPageSearchHit,
} from './services/source-navigation';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { DocsService } from '../doc';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { DocsSearchService } from './services/docs-search';

export function configureDocsSearchModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(DocsSearchService, [
      WorkspaceService,
      DocsService,
      WorkspaceServerService,
    ]);
}
